
module.exports = function(obj, keys){
  obj = obj || {};
  if ('string' == typeof keys) keys = keys.split(/ +/);
  return keys.reduce(function(ret, key){
    if (null == obj[key]) return ret;
    ret[key] = obj[key];
    return ret;
  }, {});
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/only/index.js
// module id = 85
// module chunks = 0